import { CharField, NumberField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import { Citta } from "../../types"


export default function CittaForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Citta>()
  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Nome"
        layout="horizontal"
        value={values.nome}
        onChange={(value) => {
          setFieldValue("nome", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "nome") : undefined}
        errorMessage={getIn(errors, "nome")}
        required
      />
      <NumberField
        label="Longitudine"
        layout="horizontal"
        value={values.lon}
        helperText="Ex: 12,1234"
        step={0.0001}
        onChange={(value) => {
          setFieldValue("lon", value)
        }}
      />
      <NumberField
        label="Latitudine"
        layout="horizontal"
        value={values.lat}
        helperText="Ex: 12,1234"
        step={0.0001}
        onChange={(value) => {
          setFieldValue("lat", value)
        }}
      />
    </Col>
  )
}
